import styled, { css } from 'styled-components'
import { desktopBreakpoint, tabletBreakpoint, wideScreenBreakpoint } from 'react-components'

export const Container = styled.section(
    ({ theme }) => css`
        width: inherit;
        overflow: hidden;
        padding: 0.5rem 0;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            padding: 1rem 0;
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            flex-direction: row;
            padding: 1.5rem 1.5rem 1rem;
        }

        @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
            padding: 2rem 4rem 1rem;
        }
    `,
)

export const ContentWrapper = styled.div(
    ({ theme }) => css`
        padding: 0;

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            padding-bottom: ${theme.spacing.medium};
        }
    `,
)

export const HighlightedReviewerName = styled.span`
    color: #006ad4;
    margin-left: 2px;
`

export const ReviewerSection = styled.div(
    ({ theme }) => css`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: ${theme.spacing.medium};
        padding: 1rem 1rem 1.5rem;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            padding: 1rem 1.5rem 0;
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            flex-direction: row;
            align-items: flex-start;
            margin-top: 1rem;
            padding: 0;
        }
    `,
)

export const ReviewerImageWrapper = styled.div`
    width: 8rem;
    height: 8rem;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        width: 10rem;
        height: 10rem;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        width: 8rem;
        height: 8rem;
    }
`

export const ReviewerInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    text-align: center;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 0.5rem 0;
    }
`

export const ReviewerName = styled.h3(
    ({ theme }) => css`
        margin: 0;
        font-weight: ${theme.typography.font.weight.normal};
        font-size: ${theme.typography.font.size.large};
        line-height: 1.75rem;
        color: #282828;
        letter-spacing: -0.021875rem;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            font-size: 1.75rem;
            line-height: 2.625rem;
            letter-spacing: -0.0625rem;
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            text-align: left;
            font-size: 1.25rem;
            line-height: 1.75rem;
        }
    `,
)
export const ReviewerDescription = styled.div(
    ({ theme }) => css`
        font-weight: ${theme.typography.font.weight.normal};
        font-size: 1rem;
        line-height: 1.5rem;
        color: #5f5f5f !important;
        flex: 1;
        text-align: left;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            font-size: ${theme.typography.font.size.medium};
        }
    `,
)
